export const PhiLogo = (
  <img className="h-[38px] w-[38px] mr-2" src="/dAppDomainIcons/philand.png" />
);
